import { render, staticRenderFns } from "./MenubarFooter.vue?vue&type=template&id=6aaa2787&"
import script from "./MenubarFooter.vue?vue&type=script&lang=js&"
export * from "./MenubarFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports